module.exports = __webpack_public_path__ + "static/media/quoteIcon.d45738df.svg";